import { Skeleton } from "@/components/ui/skeleton";

export function DemographicsFormSkeleton() {
  return (
    <div className="space-y-6">
      {/* Row 1: First Name / Last Name */}
      <div className="grid grid-cols-2 gap-2 sm:gap-6">
        <div className="flex w-full flex-col gap-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-10 w-full" />
        </div>
        <div className="flex w-full flex-col gap-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-10 w-full" />
        </div>
      </div>

      {/* Row 2: Gender / Age Range */}
      <div className="grid grid-cols-2 gap-2 sm:gap-6">
        <div className="flex w-full flex-col gap-2">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-10 w-full" />
        </div>
        <div className="flex w-full flex-col gap-2">
          <Skeleton className="h-4 w-20" />
          <Skeleton className="h-10 w-full" />
        </div>
      </div>

      {/* Row 3: Country / Native Language */}
      <div className="grid grid-cols-2 gap-2 sm:gap-6">
        <div className="flex w-full flex-col gap-2">
          <Skeleton className="h-4 w-18" />
          <Skeleton className="h-10 w-full" />
        </div>
        <div className="flex w-full flex-col gap-2">
          <Skeleton className="h-4 w-28" />
          <Skeleton className="h-10 w-full" />
        </div>
      </div>
    </div>
  );
}

function LanguageEntrySkeleton() {
  return (
    <div className="rounded-2xl border px-4 pb-4 shadow-sm border-primary">
      <div className="pt-4" />

      {/* Language + Proficiency row */}
      <div className="flex flex-row gap-2 flex-wrap">
        <div className="space-y-2 col-span-1 flex-grow">
          <Skeleton className="hidden sm:block h-4 w-20" />
          <div className="-space-y-1">
            <Skeleton className="h-5 w-24" />
            <Skeleton className="hidden sm:block h-4 w-32 mt-1" />
          </div>
        </div>
        <div className="space-y-2 col-span-1 flex-grow">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-10 w-full" />
        </div>
      </div>

      {/* Objectives row */}
      <div className="grid grid-cols-1 mt-4">
        <div className="flex flex-col md:flex-row md:items-center justify-end md:gap-4">
          <Skeleton className="hidden sm:block h-4 w-20" />
          <div className="flex flex-wrap gap-2">
            <Skeleton className="h-7 w-16 rounded-full" />
            <Skeleton className="h-7 w-14 rounded-full" />
            <Skeleton className="h-7 w-20 rounded-full" />
            <Skeleton className="h-7 w-18 rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
}

export function LanguageLearningObjectivesFormSkeleton() {
  return (
    <div className="col-span-3">
      <div className="space-y-4 pb-4 mb-4">
        <div className="space-y-4">
          <LanguageEntrySkeleton />
          <LanguageEntrySkeleton />
        </div>

        {/* Add entry button */}
        <div className="flex flex-col items-center justify-center">
          <Skeleton className="h-9 w-40 rounded-full" />
        </div>
      </div>
    </div>
  );
}
